export type LoggerType = (loggerInfo: TLoggerEvent) => void;

export type TLoggerEvent = TLogError | TLogWarning | TLogInformation;

export type TLogError = {
  logLevel: ELogLevel.ERROR;
  logError: Error;
};

export type TLogWarning = {
  logLevel: ELogLevel.WARNING;
  logMessage: string;
  additionalData?: IAdditionalLogData[];
};

export type TLogInformation = {
  logLevel: ELogLevel.INFORMATION;
  logMessage: string;
};

export enum ELogLevel {
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  INFORMATION = 'INFORMATION',
}

interface IAdditionalLogData {
  key: string;
  data: unknown;
}
